import { createAction } from 'redux-actions';
import { keyTransform } from 'util/helper';
import { wrapFetch } from './endpoint';

export const getAccommodationData = createAction('FETCH_ACCOMMODATION_DATA', async (lan, hotel) => {
	const { status, message, data: { common: commonData, rooms, category } } = await wrapFetch(
		`api/v1/web/${lan}/${hotel}/room`,
		{
			method: 'GET',
		},
	);

	if (status !== 200) {
		throw new Error(message);
	}

	const convertTime = time => {
		const hour = parseInt(time.split(':')[0], 10);
		const minute = time.split(':')[1];

		let ampm = 'am';
		let convertedHour = hour;
		if (hour > 12) {
			ampm = 'pm';
			convertedHour = hour - 12;
		}

		return {
			ampm,
			time: `${convertedHour}:${minute}`,
		};
	};

	const common = keyTransform(commonData[0]);

	const checkInTime = convertTime(common.checkinTime);

	const checkOutTime = convertTime(common.checkoutTime);

	const features = common.features.map(feature => {
		let label = feature.title;
		let note = '';

		if (feature.title.indexOf('/') !== -1) {
			[label, note] = feature.title.split('/');
		}

		if (feature.title.indexOf('／') !== -1) {
			[label, note] = feature.title.split('／');
		}

		return {
			id: feature.id,
			label,
			icon: feature.url,
			note,
		};
	});

	const categoryData = {};
	const categoryList = category.map(c => {
		categoryData[c.id] = { ...c, rooms: [] };
		return c.id;
	});

	const roomData = {};
	const roomList = rooms.map((r, index) => {
		roomData[index] = {
			id: index,
			roomName: r.title,
			roomSize: r.area,
			bedType: r.bed,
			detail: r.equip,
			images: r.photos.map(img => img.url),
			thumbnail: r.photos.map(img => img.thumb_url),
		};
		categoryData[r.category.id].rooms.push(index);
		return index;
	});

	return {
		checkInTime,
		checkOutTime,
		features,
		categoryList,
		categoryData,
		roomList,
		roomData,
	};
});



// WEBPACK FOOTER //
// ./src/actions/accommodation.js